// extracted by mini-css-extract-plugin
module.exports = {"melodyCardCategory":"si-z","categoryName":"ti-z","categoryImage":"ui-z","categoryContent":"vi-z","bottomAligned":"wi-z"};